jQuery(document).ready(function($) {

	const $body = $('body');
	const $window = $(window);
	const $document = $(document);
	const $html = $('html');

	altToTitle($);
	reverseColors($, $body);
	smoothScroll($);
	hamburgerToggle($, $body, $window);
	//submenuToggle($, $body, $window);
	pageIsScrolled($, $body, $window, $document);
	vhResize($, $window);
	videoControls($);
	skillsDropdown($, $window, $html);
	helperModal($, $body, $window);

	// launch AOS at first scroll tick
	var aosinit = false;
	if(!aosinit){
		AOS.init({
			offset: $window.innerHeight()/4,
			duration: 800
		});
		aosinit = true;
	}

});

jQuery(window).on("load", function($) {
	jQuery("body").removeClass("preload");
});

function altToTitle($){
	$('img').each(function () {
		$this = $(this);
		if (!$this.attr('title') && $this.attr('alt')) {
			$this.attr('title', $this.attr('alt'));
		}
	});
}

function helperModal($, $body, $window) {
	const $technicalHelper = $('.js-technical-helper');
	const $technicalHelperTrigger = $('.js-technical-helper-trigger');
	$('.js-technical-helper-trigger').on('click', function(e) {
		e.stopPropagation();
		$technicalHelperTrigger.toggleClass('active');
		$technicalHelper.toggleClass('active');
		$body.toggleClass('technical-helper-active');
	});
	$technicalHelper.on('click', function (e) {
		e.stopPropagation();
	});
	$window.on('click', function () {
		$technicalHelperTrigger.removeClass('active');
		$technicalHelper.removeClass('active');
		$body.removeClass('technical-helper-active');
	});
}

function reverseColors($, $body){

	var reverseStorage = localStorage.getItem('reverse');

	if(reverseStorage == null){
		localStorage.setItem('reverse', 'false');
	}else{
		if(reverseStorage == 'true'){
			$body.addClass('reverse');
			$('.js-reverse-colors').prop( "checked", true );
		}
	}

	$body.on('change', '.js-reverse-colors', function() {
		if(this.checked) {
			localStorage.setItem('reverse', 'true');
			$body.addClass('reverse');
		}
		if(this.checked == false) {
			localStorage.setItem('reverse', 'false');
			$body.removeClass('reverse');
		}
	});

}

function skillsDropdown($, $window, $html) {

	const $dropdown = $('#primary-menu').find('.dropdown-menu');
	const $dropdownTrigger = $dropdown.find('.js-dropdown-trigger');
	const $dropdownMenu = $dropdown.find('.js-dropdown');
	const $hoverImage = $dropdown.find('.js-hover-image');
	const defaultImageUrl = $hoverImage.data('default-image');
	const $menuItem = $dropdown.find('.js-menu-skill a');

	setDefaultImage(defaultImageUrl);

	$dropdownTrigger.on('click', function(e) {

		e.preventDefault();
		e.stopPropagation();
		
		$dropdownTrigger.removeClass('active');
		$dropdownMenu.removeClass('dropdown-active');
		$html.removeClass('dropdown-menu-active');
		
		$(this).toggleClass('active');
		$(this).next('.js-dropdown').toggleClass('dropdown-active');
		$html.toggleClass('dropdown-menu-active');

	});

	$dropdownMenu.click(function(e){
		e.stopPropagation();
	});

	$window.on('click', function() {
		$dropdownTrigger.removeClass('active');
		$dropdownMenu.removeClass('dropdown-active');
		$html.removeClass('dropdown-menu-active');
	});

	$menuItem.on('mouseover', function() {
		const $imageUrl = $(this).data('hover');
		$hoverImage.addClass('transition');
		$hoverImage.css('background-image', 'url("' + $imageUrl + '")');
	});
	$menuItem.on('mouseleave', function() {
		$hoverImage.removeClass('transition');
		setDefaultImage(defaultImageUrl);
	});

	function setDefaultImage(defaultImageUrl) {
		$hoverImage.css('background-image', 'url("' + defaultImageUrl + '")');
	}

}


function vhResize($, $window){
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
	$window.on( 'resize', function() {
		vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	});
}

function pageIsScrolled($, $body, $window, $document) {

	scrollClasses();
 
	$window.on( 'scroll', function() {
		scrollClasses();
	});

	function scrollClasses() {		
		var $spacer = 0;
		$body.toggleClass('scrolled', $document.scrollTop() > $spacer);		
	}

}

function hamburgerToggle($, $body, $window) {
	const $hamburgerIcon = $('.hamburger-toggle');
	$hamburgerIcon.on("click", function(e) {
		$('body').toggleClass('primary-menu-active');
	});
}

function submenuToggle($, $body, $window) {
	const $subMenu = $('.menu-item-has-children > a');
	$subMenu.on("click", function(e) {
		e.preventDefault();
		e.stopPropagation();
		//$(this).parent().toggleClass('submenu-menu-active');
		
	});
	$window.on('click', function() {
		//$('.menu-item-has-children.submenu-menu-active').removeClass('submenu-menu-active');
	});
}


function getCssVar(type, cssvar, intslice = -2) {
	let cssvalue = '';	
	if ( 'CSS' in window && CSS.supports && CSS.supports('(--foo: red)' ) ) {
		if(type == 'int'){
			cssvalue = parseInt(getComputedStyle(document.documentElement).getPropertyValue(cssvar).slice(0,intslice));
		}
		if(type == 'string'){
			cssvalue = getComputedStyle(document.documentElement).getPropertyValue(cssvar);
		}
	}
	return cssvalue;
}

function µSpacer(factor = 1) {
	let spacer = 32;
	if ( 'CSS' in window && CSS.supports && CSS.supports('(--foo: red)' ) ) {
		spacer = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--spacer-current').slice(0,-2));
	}
	return spacer * factor;
}

function smoothScroll($) {
	$('a[href*=\\#]:not([href=\\#])').click(function(e) {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
			if (target.length) {
				smoothScrollTo(target);
				e.preventDefault();
			}
		}				
	});
}


function sendAjax($form, settings, callback) {
	
	(function ($) {

        grecaptcha.ready(function() {

			grecaptcha.execute( settings.reCaptcha.siteKey, {action: settings.reCaptcha.action}).then(function(token) {

				const $requiredCheckboxes = $form.find('input[type=checkbox][required]').prop('checked');

				$form.ajaxSubmit({
					url: settings.adminAjaxUrl,
					type: 'POST',
					contentType: 'json',
					beforeSubmit: function(formData, jqForm, options) {
						let error = false;
						for ( var i = 0; i < formData.length; i++ ) {
							if ( formData[i].required && !formData[i].value ) {
								error = true;
								$form.find('[name="'+formData[i].name+'"], [for="'+formData[i].name+'"]').addClass('required');
							}
						}
						$form.find('input[type=checkbox][required]').each(function() {
							const $checkbox = $(this);
							if (!$checkbox.prop('checked')) {
								$form.find('[for="'+$checkbox.attr('id')+'"]').addClass('required');
								$checkbox.addClass('required');
								error = true;
							}
						});
						if ( error ) {
							$('<div class="uncomplete">'+settings.strings.uncompleteNotice+'</div>').insertAfter($form.find('[type="submit"]'));
							return false;
						}
						else {
							$form.find('.error').remove();
							$form.find('.required').removeClass('required');
						}
					},
					data: {
						token: token,
					},
					clearForm: true,
					success: function(res) {
						if (callback) callback(res);
						if (res.success != true) {
							console.log(res);
						}
					}
				});

			});
			
		});

	})(jQuery);

}


function videoControls($) {

	const $videoContainers = $('.js-video-container');
	if (!$videoContainers.length) return;

	$videoContainers.each( function() {

		const $videoContainer = $(this);
		const $video = $videoContainer.find('.js-video');
		const videoDomElem = $video.get(0);
		const $playButton = $videoContainer.find('.js-play');
		const $fullscreenButton = $videoContainer.find('.js-fullscreen');
	
		$video.on( 'playing', function() { 
			$videoContainers.addClass('playing');
		});
		$video.on( 'pause', function() { 
			$videoContainers.removeClass('playing');
		});
		$playButton.on( 'click', function() { playVideo($video, $playButton) });
		$fullscreenButton.on( 'click', function() { fullscreenVideo(videoDomElem) } );

	});

	function playVideo($video, $playButton) {

		if ( $video.prop('paused') ) {
			$video.trigger('play');
			$playButton.removeClass('icon-play');
			$playButton.addClass('icon-pause');
		}
		else {
			$video.trigger('pause');
			$playButton.removeClass('icon-pause');
			$playButton.addClass('icon-play');
		}
  
	}
  
	function fullscreenVideo(videoDomElem) {
		if (videoDomElem.requestFullscreen) {
			videoDomElem.requestFullscreen();
		} else if (videoDomElem.mozRequestFullScreen) { /* Firefox */
			videoDomElem.mozRequestFullScreen();
		} else if (videoDomElem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
			videoDomElem.webkitRequestFullscreen();
		} else if (videoDomElem.msRequestFullscreen) { /* IE/Edge */
			videoDomElem.msRequestFullscreen();
		}
	}
  
  
}


/**
 * inViewport jQuery plugin by Roko C.B.
 * http://stackoverflow.com/a/26831113/383904
 * Returns a callback function with an argument holding
 * the current amount of px an element is visible in viewport
 * (The min returned value is 0 (element outside of viewport)
 */
 ;(function($, win) {
	$.fn.inViewport = function(cb) {
	   	return this.each(function(i,el) {
			function visPx(){
				var elH = $(el).outerHeight(),
					H = $(win).height(),
					r = el.getBoundingClientRect(), t=r.top, b=r.bottom;
				return cb.call(el, Math.max(0, t>0? Math.min(elH, H-t) : Math.min(b, H)));  
			}
		visPx();
	   });
	};
  }(jQuery, window));


function smoothScrollTo($target) {
	$('html,body').animate({
		scrollTop: $target.offset().top-(µSpacer(2))
	}, 800);
}